import {
  ShieldCheck,
  HandCoins,
  Clock,
  HeartHandshake,
  FileCheck,
  Headphones,
} from "lucide-react";

const FEATURES = [
  {
    icon: ShieldCheck,
    title: "Trusted Insurers",
    desc: "Top IRDAI-licensed insurance partners — only the best brands on board.",
  },
  {
    icon: HandCoins,
    title: "Lowest Premium",
    desc: "We compare plans across insurers to find you the most affordable cover.",
  },
  {
    icon: FileCheck,
    title: "Transparent Claims",
    desc: "Step-by-step claim assistance with full transparency — no hidden clauses.",
  },
  {
    icon: Clock,
    title: "Quick Process",
    desc: "Get policies issued in minutes — paperless, contactless and stress-free.",
  },
  {
    icon: HeartHandshake,
    title: "Personalised Advice",
    desc: "Real insurance experts who understand your needs, not just sell policies.",
  },
  {
    icon: Headphones,
    title: "24×7 Support",
    desc: "Call, WhatsApp or visit us anytime — we are with you when it matters most.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-16 md:py-24 bg-white relative overflow-hidden"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <span className="eyebrow">Why Beemamen</span>
            <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">
              Hum sirf<br /> policy nahi <span className="text-[#1e3a8a]">bechte</span> — <br/>
              <span className="text-[#f5b942]">bharosa</span> deliver karte hain.
            </h2>
            <p className="font-hindi mt-4 text-lg text-slate-600 leading-relaxed">
              हमारी पहचान है — सही सलाह, पारदर्शी सेवा और हर पल आपके साथ खड़े रहने का वादा।
            </p>
            <div className="mt-8 p-6 rounded-2xl bg-[#1e3a8a] text-white">
              <div className="text-sm opacity-80">Claim Settlement Ratio</div>
              <div className="font-display text-4xl md:text-5xl font-extrabold mt-1">
                98.7%
              </div>
              <div className="text-sm opacity-80 mt-2">
                In FY 2024-25, based on partnered insurers data.
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {FEATURES.map((f, i) => {
              const Icon = f.icon;
              return (
                <div
                  key={f.title}
                  data-testid={`why-us-card-${i}`}
                  className="p-6 rounded-2xl border border-slate-200 bg-white hover:border-[#f5b942] hover:shadow-lg transition-all hover:-translate-y-0.5"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#fef3c7] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#92400e]" />
                  </div>
                  <h3 className="font-display mt-4 text-lg font-bold text-slate-900">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
